import { navLinks } from "@/mocks/home";

function Footer() {
  return (
    <footer className="bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">哔咔漫画</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              哔咔漫画翻页音效与翻页动画体验专区，用真实纸感声画还原沉浸式纸质漫画阅读，
              陪你追更每一部喜爱的作品。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-line", "ri-wechat-line", "ri-bilibili-line", "ri-mail-line"].map((i) => (
                <a
                  key={i}
                  href="#top"
                  aria-label="社交平台链接"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${i} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-foreground-950">站点导航</h4>
            <ul className="mt-3 space-y-2">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <a href={`#${l.id}`} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-foreground-950">联系我们</h4>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              意见反馈与商务合作，欢迎发送邮件至：
            </p>
            <a
              href="mailto:hello@bika-comic.example"
              className="mt-2 inline-flex items-center gap-2 text-sm font-medium text-primary-600"
            >
              <i className="ri-mail-send-line"></i>
              hello@bika-comic.example
            </a>
            <p className="mt-4 text-xs text-foreground-500">
              工作时间：周一至周五 9:00 – 18:00
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} 哔咔漫画 · 纸感阅读体验站</p>
          <p className="flex items-center gap-1">
            <i className="ri-heart-3-line text-primary-500"></i>
            让每一页翻动都有声音
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;